import styles from "./Shorts.module.scss";
import { FC, lazy, Suspense, useEffect, useState } from "react";
import { withStockStamp } from "@/components/stock-stamp-hoc/StockStampHOC";
import { classNames } from "@/lib/utils";
import { Box } from "@mui/system";
import { CircularProgress, Typography, useMediaQuery } from "@mui/material";
const MUILineChart = lazy(() => import("@/components/line-chart/MUILineChart"));

interface PropsTypes {
    overviewPage?: boolean;
    row?: any;
    shortChangePcRaw: number;
    shortChangeRaw: number;
    shortFFNow: number;
    shortsTs: number[];
    mobile?: boolean;
    obfuscated?: boolean;
}

const Shorts: FC<PropsTypes> = ({ overviewPage, row, shortChangePcRaw, shortChangeRaw, shortFFNow, shortsTs, mobile, obfuscated }) => {
    const isLargeScreen = useMediaQuery("(min-width: 2560px)");
    const [fontSize, setFontSize] = useState("10px");

    useEffect(() => {
        if (isLargeScreen) {
            setFontSize("18px");
        } else {
            setFontSize("10px");
        }
    }, [isLargeScreen]);

    return overviewPage ? (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <Box sx={{ height: "20%", fontSize: overviewPage && fontSize }}>
                <p style={{ color: "var(--text-3, #8a8f97)", textTransform: "initial" }}>Currently {shortFFNow?.toFixed(2)}%</p>
            </Box>

            <Box sx={{ height: "20%", width: "90%", marginX: "auto", display: "flex", justifyContent: "space-between" }}>
                <Typography variant="moduleContentTitle">{shortChangeRaw?.toFixed(2)}%</Typography>
                <Typography variant="moduleContentTitle" className={shortChangePcRaw < 0 ? "negative" : "positive"}>
                    {shortChangePcRaw?.toFixed(2)}%
                </Typography>
            </Box>

            <Box sx={{ height: "60%" }}>
                <Suspense
                    fallback={
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                            <CircularProgress size={30} />
                        </div>
                    }
                >
                    <MUILineChart data={shortsTs} id={row && row.stock.ticker + row.shorts.box_name} labels={["-3m", "-2m", "-1m"]} labelsAlign={"left"} obfuscated={obfuscated} />
                </Suspense>
            </Box>
        </Box>
    ) : (
        <div className={classNames(styles.Shorts, styles[overviewPage && "overview-page"])}>
            <p className={styles.currently} style={{ color: "var(--text-3, #8a8f97)", textTransform: "initial" }}>
                Currently {shortFFNow?.toFixed(2)}%
            </p>
            <div className={styles.values}>
                <Typography variant={mobile ? "h2" : "moduleContentTitle"}>{shortChangeRaw?.toFixed(2)}%</Typography>
                <Typography variant={mobile ? "h2" : "moduleContentTitle"} className={shortChangePcRaw < 0 ? "negative" : "positive"}>
                    {shortChangePcRaw?.toFixed(2)}%
                </Typography>
            </div>
            <div className={styles.chart}>
                <Suspense
                    fallback={
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                            <CircularProgress size={30} />
                        </div>
                    }
                >
                    <MUILineChart data={shortsTs} id={row && row.stock.ticker + row.shorts.box_name} labels={["-3m", "-2m", "-1m"]} labelsAlign={"left"} obfuscated={obfuscated} />
                </Suspense>
            </div>
        </div>
    );
};

export default withStockStamp(Shorts, "shortFFNow", { title: "% of FF Change 5D" }, "Shorts");
